/**
 * API / Redux sometimes send booleans as strings. Avoid:
 * - Boolean("false") === true (wrong ON state)
 * - "true" !== true (spurious "changed" vs catalog default)
 */

export function isExplicitlyOn(value: unknown): boolean {
  return value === true || value === 1 || value === 'true' || value === '1';
}

/** Interpret filter toggle storage; null/undefined → fallback (catalog / Redux default). */
export function coerceFilterBoolean(value: unknown, fallback: boolean): boolean {
  if (value === null || value === undefined) return fallback;
  return isExplicitlyOn(value);
}
